import Common from "../common/Common";

class Accordion1 {
  constructor() {
    this.common = new Common();
    this.mediaQueryList = this.common.matchMedia("md");
    this.smAccordion1 = document.querySelectorAll(".js-smAccordion1");
    this.smAccordion1Flag = true;

    this.initialize();
  }

  initialize() {
    if( this.smAccordion1 ) {
      this.accordion1();
    }
  }
  accordion1() {
    this.smAccordion1.forEach(( button , i ) => {
      button.addEventListener("click", (e) => {
        if (this.mediaQueryList.matches) {
          const expanded = e.currentTarget.getAttribute("aria-expanded") === "true";
          e.currentTarget.setAttribute("aria-expanded", String(!expanded));

          if (this.smAccordion1Flag) {
            // 表示する
            this.smAccordion1Flag = false;
            e.currentTarget.setAttribute("aria-label", "アコーディオンを閉じる");
          } else {
            // 非表示にする
            this.smAccordion1Flag = true;
            e.currentTarget.setAttribute("aria-label", "アコーディオンを開く");
          }
        }
      });
    });
  }

}

export default Accordion1;